export const PLAN_TYPE = {
	PERSONAL: "personal",
	GROUP: "group",
};

export const isPlanCodeValid = planCode =>
	typeof planCode === "string" && // not null
	planCode !== "" && // not empty string
	/[a-z]{2}(?:_[a-z]+)+_[a-z]+/i.test(planCode); // br_group_name_period

export const isGroupPlan = plan => plan.type === PLAN_TYPE.GROUP;
export const isPersonalPlan = plan => plan.type === PLAN_TYPE.PERSONAL;

export const unionByPlans = plansAndPrices => {
	const res = [];
	if (!Array.isArray(plansAndPrices)) {
		return res;
	}

	for (let i = 0; i < plansAndPrices.length; i += 1) {
		const index = res.findIndex(item => item?.newPlanCode === plansAndPrices[i].newPlanCode);

		if (index !== -1) {
			res[index].prices.push(plansAndPrices[i]);
		} else {
			res.push({
				newPlanCode: plansAndPrices[i].newPlanCode,
				newPlanName: plansAndPrices[i].newPlanName,
				minActivaions: plansAndPrices[i].subscriptionSize,
				maxActivaions: plansAndPrices[plansAndPrices.length - 1].subscriptionSize,
				prices: [plansAndPrices[i]],
			});
		}
	}

	return res;
};

export const isIsul = planCode => /^.*_isul$/.test(planCode);

export const isIsulGroup = planCode => /^gn_group.*_isul$/.test(planCode);
